module.exports = __webpack_public_path__ + "img/dXqmyKuY.3f49dbc5.svg";